import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = { class: "d-flex align-center py-4 pl-4 justify-space-between" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center ga-4"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex align-center ga-4"
}
const _hoisted_4 = { class: "d-flex align-center ga-3" }
const _hoisted_5 = { class: "font-size-12-400" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "font-size-12-400 d-flex justify-space-between w-100" }
const _hoisted_8 = { class: "font-size-12-600" }
const _hoisted_9 = { class: "py-4" }
const _hoisted_10 = { class: "d-flex align-center justify-space-between" }
const _hoisted_11 = { class: "font-size-16-600" }
const _hoisted_12 = { class: "text-center py-8" }
const _hoisted_13 = { class: "pt-4" }
const _hoisted_14 = { href: "mailto:{{ reportIssueWithOrder.email }}" }

import {computed, reactive, shallowRef} from 'vue';
import {useRoute, useRouter} from 'vue-router';

import {ordersService} from '@/api/services/order';
import {useSettingsStore} from '@/api/store/settings';

import OrderCardView from "@/views/OrdersComponents/OrderDetails/OrderCardView.vue";
import Icon from "@/components/Icons/Icon.vue";
import ButtonBase from "@/components/custom/ButtonBase.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const settingsStore = useSettingsStore();

const state = reactive({
  orders: null as any,
  order: null as any,
  hasCardPayments: false,
  hasManualPayments: false,
  loaded: false,
});

const dialog = shallowRef(false)

const getOrder = () => {
  
  ordersService.show(+route.params.id).then((response) => {
    state.orders = response.data;
    state.order = response.order;
    state.hasCardPayments = response.has_card_payments;
    state.hasManualPayments = response.has_manual_payments;
  }).catch((error) => {
    console.log(error);
  }).finally(() => {
    
    state.loaded = true;
  });
}

// Computed
const getOrderType = computed(() => {
  let hasBooking = state.order.items.some(
      e => e.type === 'clinic_package' || e.type == 'package'
  );
  let hasProduct = state.order.items.some(
      e => e.type === 'clinic_product' || e.type == 'supplement'
  );
  let hasService = state.order.items.some(
      e => e.type === 'service' || e.type === 'clinic_service'
  );

  if (hasBooking && !hasProduct) {
    return "Package";
  } else if (!hasBooking && hasProduct) {
    return "Product";
  } else if (hasService && !hasProduct && !hasBooking) {
    return "Service";
  } else {
    return "Packages & Services & Products";
  }
})

const getShippingAddress = computed(() => {
  return state.order?.shipping_address;
})

const getShippingMethod = computed(() => {
  return state.order.items.length > 0 ? state.order.items.filter(order => order.type === 'shipping_method') : [];
})

const orderTotalPayment = computed(() => {
  return state.order.total_display ?? '-';
})

const reportIssueWithOrder = computed(() => {
  let isNonND = state.order.items.every(
      e => e.supplier_id === null
  );

  let isND = state.order.items.every(
      e => e.supplier_id !== null
  );

  if (isNonND) {
    return {
      clinic: 'Please make contact with your clinic'
    }
  } else if (isND) {
    return {
      nd: 'Please send an email with your issue to',
      email: 'naturaldispensaryorders@swandoola.com'
    }
  } else {
    return {
      clinic: 'and contact your clinic',
      nd: 'Please send an email regarding your issue to',
      email: 'naturaldispensaryorders@swandoola.com'
    }
  }
})

const openPurchase = () => {
  //redirect to orders/payment/:id in this app using router
  router.push({name: 'order-payment', params: {id: state.order.id}});
};

getOrder();

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (state.order)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "pa-0",
        style: {"background-color":"#F0F0F0","min-height":"100vh"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.orders, (order) => {
            return (_openBlock(), _createElementBlock("section", {
              key: order.id,
              class: "pa-4"
            }, [
              _createVNode(OrderCardView, {
                "clinic-avatar": order.clinic_avatar,
                "has-multiple-orders": state.orders.length > 1,
                order: state.order,
                "order-items": order.items,
                "order-type": getOrderType.value,
                "supplier-id": order.supplier_id,
                "supplier-order": order
              }, null, 8, ["clinic-avatar", "has-multiple-orders", "order", "order-items", "order-type", "supplier-id", "supplier-order"])
            ]))
          }), 128)),
          (state.order.payment_status === 'paid')
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                class: "card-container"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "font-size-18-600 px-0" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" Payment Method ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_1, [
                    (state.hasCardPayments)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(Icon, { icon: "card-icon" }),
                          _cache[4] || (_cache[4] = _createTextVNode(" Online ", -1))
                        ]))
                      : _createCommentVNode("", true),
                    (state.hasManualPayments)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(Icon, { icon: "cash-icon" }),
                          _cache[5] || (_cache[5] = _createTextVNode(" Cash ", -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(ButtonBase, {
                      "custom-class": "text-white b-round-20 outline-btn white-btn",
                      disabled: "",
                      text: "View Payments",
                      width: "150px"
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (getShippingAddress.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 1,
                class: "card-container"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "font-size-18-600 px-0" }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Shipping ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("section", null, [
                    _createVNode(_component_v_card_title, { class: "font-size-14-600 px-0" }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode(" Shipping Address ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(Icon, { icon: "address-icon" }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, _toDisplayString(getShippingAddress.value.address_1) + " " + _toDisplayString(getShippingAddress.value.city) + " " + _toDisplayString(getShippingAddress.value.post_code) + ", ", 1),
                        _createElementVNode("p", null, _toDisplayString(getShippingAddress.value.country), 1)
                      ])
                    ])
                  ]),
                  (getShippingMethod.value.length > 0)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                        _createVNode(_component_v_card_title, { class: "font-size-14-600 px-0" }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode(" Shipping Method ", -1)
                          ]))]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getShippingMethod.value, (shipping, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `shipping-${index}`,
                            class: "d-flex align-center ga-3 pb-4"
                          }, [
                            _createVNode(Icon, { icon: "shipping-icon" }),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("p", null, _toDisplayString(shipping.name), 1),
                              _createElementVNode("p", _hoisted_8, _toDisplayString(shipping.price_display), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (state.order.payment_status !== 'paid')
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 2,
                class: "card-container"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[9] || (_cache[9] = _createElementVNode("p", null, "Total Payment:", -1)),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(orderTotalPayment.value), 1)
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            (state.order.payment_status !== 'paid')
              ? (_openBlock(), _createBlock(ButtonBase, {
                  key: 0,
                  class: "mb-3",
                  "custom-class": "text-white primary-button",
                  text: "Pay Now",
                  onClick: openPurchase
                }))
              : _createCommentVNode("", true),
            _createVNode(ButtonBase, {
              "with-bg": false,
              "button-color": "buttonColor",
              "custom-class": "font-size-12-600",
              text: "Report Issue With Order",
              onClick: _cache[0] || (_cache[0] = () => dialog.value = true)
            })
          ]),
          _createVNode(_component_v_dialog, {
            modelValue: dialog.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event)),
            width: "auto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { "max-width": "400" }, {
                text: _withCtx(() => [
                  _createElementVNode("p", _hoisted_13, [
                    _createTextVNode(_toDisplayString(reportIssueWithOrder.value.nd) + " ", 1),
                    _createElementVNode("a", _hoisted_14, _toDisplayString(reportIssueWithOrder.value.email), 1),
                    _createTextVNode(" " + _toDisplayString(reportIssueWithOrder.value.clinic), 1)
                  ])
                ]),
                actions: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "ms-auto",
                    text: "Ok",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (dialog.value = false))
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (state.orders.length == 0)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 3,
                class: "mt-4 mx-4 mb-3",
                height: "50vh"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    class: "my-2 py-1",
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "my-1 px-10 text-center",
                        cols: "12"
                      }, {
                        default: _withCtx(() => [
                          (!_unref(settingsStore).loading)
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                type: "info",
                                variant: "tonal"
                              }, {
                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                  _createTextVNode("No Orders Found", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})